import { render, staticRenderFns } from "./tjsfdx.vue?vue&type=template&id=d8b82dc0&scoped=true&"
import script from "./tjsfdx.vue?vue&type=script&lang=js&"
export * from "./tjsfdx.vue?vue&type=script&lang=js&"
import style0 from "./tjsfdx.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tjsfdx.vue?vue&type=style&index=1&id=d8b82dc0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b82dc0",
  null
  
)

export default component.exports